import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatActivityDate } from '@/utils/dates';
import { translateActivityTitle } from '@/utils/translateActivity';

interface Props {
  id: string;
  title: string;
  details: string;
  created_at: string;
  submission_id: string;
}

export const Activity: React.FC<Props> = ({
  id: _id,
  created_at,
  details,
  title,
  submission_id,
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <div className="py-4 first:pt-0 last:pb-0">
      <div className="flex items-center gap-3 mb-1">
        <p className="text-gray-900">
          <strong>{translateActivityTitle(title, t)}</strong>
        </p>
        <span className="text-sm text-gray-400">
          {formatActivityDate(created_at, i18n.language)}
        </span>
      </div>
      <div className="flex items-start justify-between">
        <p className="text-sm text-gray-600">{details}</p>
        <button
          onClick={() => navigate(`/submissions/${submission_id}`)}
          className="hover:underline cursor-pointer text-sm ml-4 flex-shrink-0 text-primary"
        >
          {t('dashboard.view_details')}
        </button>
      </div>
    </div>
  );
};
